import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";
import line from "../../assets/images/png/line.png";

const steps = [
  {
    number: "01",
    title: "Idea",
    text: "From innovation comes clarity — a focused idea. This stage involves identifying a core concept that is meaningful, relevant, and has the potential to grow into a scalable solution.",
    side: "right",
    color: "bg-blue-600",
  },
  {
    number: "02",
    title: "Research & Development",
    text: "Ideas need shaping. Through deep research and development, we analyze feasibility, market needs, and technical execution to ensure the idea evolves into a viable product or service.",
    side: "left",
    color: "bg-green-500",
  },
  {
    number: "03",
    title: "Manufacturing",
    text: "This is where concepts become reality. We move into structured production, ensuring quality, precision, and consistency to deliver a product ready for market impact.",
    side: "right",
    color: "bg-yellow-400",
  },
  {
    number: "04",
    title: "Distribution",
    text: "Once produced, the product reaches the world. A strategic distribution network ensures timely delivery, wide reach, and market availability across all necessary channels.",
    side: "left",
    color: "bg-pink-500",
  },
  {
    number: "05",
    title: "Sales & Service",
    text: "Beyond selling, we focus on customer experience. Our sales team connects with users, while the service team ensures satisfaction, support, and long-term trust.",
    side: "right",
    color: "bg-blue-700",
  },
  {
    number: "06",
    title: "Collaboration",
    text: "Growth thrives on partnership. We foster strong collaborations with stakeholders, partners, and customers to scale sustainably and innovate continuously.",
    side: "left",
    color: "bg-yellow-500",
  },
];

const Roadmap = () => {
  return (
    <div className="relative w-full max-w-4xl mx-auto sm:py-16 pt-16 pb-10">
      <div className="flex items-center justify-center flex-col">
        <BlueTag center>Concept Creation</BlueTag>
        <Heading className=" mb-5 pt-2 text-center">Innovation</Heading>
        <p className="text-[#5E5C5C] text-[26px] text-center max-md:text-base font-normal leading-[150%] pb-12">
          Every great journey begins with a spark. Innovation is the foundation
          where new possibilities are explored, setting the stage for
          transformation and unique offerings.
        </p>
      </div>

      <div className="relative">
        <div className="absolute left-1/2 top-1/2 lg:h-[970px] h-[900px] lg:w-30 w-30 transform -translate-x-1/2 -translate-y-1/2 hidden md:block">
          <img className="w-full h-full" src={line} alt="line" />
        </div>

        <div className="md:space-y-1 space-y-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`flex items-center w-full ${
                step.side === "left" ? "flex-row-reverse" : "flex-row"
              }`}
            >
              <div className="w-1/2 px-6 max-w-[350px] text-center max-md:w-full max-md:max-w-full max-md:px-4  flex flex-col justify-center items-center">
                <div
                  className={`w-12 h-12 sm:hidden flex items-center justify-center rounded-full text-white font-bold mb-2 ${step.color}`}
                >
                  {step.number}
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 max-md:text-lg">
                  {step.title}
                </h3>
                <p className="lg:mt-3 mt-1 text-base text-[#686868] max-md:text-sm">
                  {step.text}
                </p>
              </div>
              <div className="w-1/2 max-md:hidden" />{" "}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Roadmap;
